import AudiencePage from "@/components/AudiencePage";

const INCLUDED = [
  ["Regular, on-time stocking", "We restock on a dependable schedule shaped by what your practice goes through — drinks, snacks, and lighter options for people who may be waiting a while."],
  ["Cleaning on every visit", "In a healthcare setting this is non-negotiable: every service visit includes a full machine wipe-down and a freshness check of everything inside."],
  ["Maintenance handled by us", "Cooler, screen, or card reader issues are serviced by us end to end. Your office staff never fields equipment problems."],
  ["Custom product selection", "The mix is set for your practice — including better-for-you options — and anyone can request items by scanning the QR code on the machine."],
  ["Prompt response to issues", "Call, email, or scan the QR code on the machine. A real person follows up fast, Monday–Friday, 8 AM – 8 PM."],
];

const FAQS = [
  {
    q: "What does it cost our practice?",
    a: "Nothing. There is no cost to your practice: we provide the smart cooler, install it, and handle all stocking, cleaning, and maintenance. Staff and visitors pay only for the items they buy.",
  },
  {
    q: "Is a smart cooler appropriate for a waiting room?",
    a: "Yes. The cooler runs quietly, and the glass front lets patients and families see exactly what is available before they tap to pay. It gives people sitting through long appointments — or parents with restless kids — an easy option without leaving the building.",
  },
  {
    q: "What about our staff on long or late shifts?",
    a: "That is where a smart cooler earns its keep. Nurses, techs, and front-desk staff on extended shifts can grab a drink or a real snack in under a minute, any time the staff area is open — no vending coils, no cash, no leaving the building mid-shift.",
  },
  {
    q: "How is the machine kept clean enough for a medical setting?",
    a: "Every service visit includes a full wipe-down of the machine, inside contact surfaces, and the door handle area, plus a freshness check of all products. Clean, well-maintained equipment is the baseline of our service, not an add-on.",
  },
  {
    q: "Can we request healthier options for patients and staff?",
    a: "Yes — the product mix is customized for your practice, and we can emphasize water, seltzers, and lighter snacks alongside the usual favorites. Staff and visitors can also request items through the QR code on the machine.",
  },
  {
    q: "Who do we call if something goes wrong?",
    a: "Us — directly, at (610) 983-8060, or through the QR code on the machine. We respond promptly during service hours (Monday–Friday, 8 AM – 8 PM), and all equipment maintenance is handled by our team.",
  },
];

const MedicalVending = () => (
  <AudiencePage
    testId="medical-vending-page"
    overline="For Medical Offices & Clinics"
    h1Lines={["SMART COOLER VENDING FOR", "MEDICAL OFFICES IN", "WEST CHESTER, PA."]}
    accentIndex={2}
    intro="Long shifts for your staff, long waits for patients and families. A clean, well-maintained smart cooler in the break room or waiting area takes care of both — without adding work for your front desk."
    howTitle="Quiet, clean, and always ready."
    howText="We place a glass-front smart cooler in your staff break room or waiting area. Anyone browses through the glass, taps a card or phone on the reader, and the door unlocks — no coins, no coils, no stuck bags. The machine reports its inventory to us so restocks arrive before shelves thin out, and every visit includes a full clean-down suited to a healthcare environment."
    included={INCLUDED}
    faqs={FAQS}
    imageKey="interior"
    imageAlt="Stocked shelves of a Vortex smart cooler in a medical office"
  />
);

export default MedicalVending;
